import React, { useMemo } from "react";
import { Card, Typography, Space } from "antd";

const { Title, Text } = Typography;

function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

// Полукруглый кастомный спидометр на SVG
export default function GaugeHalfCircle({ fact = 0, plan = 0, title = "", subtitle = "% выполнения", size = 260 }) {
  const pct = useMemo(() => (plan > 0 ? Math.round((fact / plan) * 100) : 0), [fact, plan]);
  const percent = clamp(pct, 0, 200); // позволяем до 200% для перепланов

  const width = size;
  const height = Math.round(size / 2);
  const cx = width / 2;
  const cy = height;
  const r = Math.min(width, height) - 20;
  const startAngle = Math.PI; // 180°
  const endAngle = 0;
  const angle = startAngle + (endAngle - startAngle) * clamp(percent / 100, 0, 1);

  const arcPath = (angleFrom, angleTo, radius) => {
    const x1 = cx + radius * Math.cos(angleFrom);
    const y1 = cy + radius * Math.sin(angleFrom);
    const x2 = cx + radius * Math.cos(angleTo);
    const y2 = cy + radius * Math.sin(angleTo);
    const largeArc = angleTo - angleFrom <= Math.PI ? 0 : 1;
    return `M ${x1} ${y1} A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2}`;
  };

  const needleX = cx + (r - 6) * Math.cos(angle);
  const needleY = cy + (r - 6) * Math.sin(angle);

  return (
    <Card className="rob-card" style={{ width }} bodyStyle={{ padding: 16 }}>
      {title && <Title level={5} style={{ marginBottom: 8 }}>{title}</Title>}
      <div style={{ position: "relative", width, height }}>
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
          {/* фон дуги */}
          <path d={arcPath(startAngle, endAngle, r)} stroke="#e9edf5" strokeWidth={12} fill="none" />
          {/* активная дуга */}
          <path d={arcPath(startAngle, angle, r)} stroke="#2ec4b6" strokeLinecap="round" strokeWidth={12} fill="none" />
          {/* стрелка */}
          <line x1={cx} y1={cy} x2={needleX} y2={needleY} stroke="#ffb703" strokeWidth={4} />
          <circle cx={cx} cy={cy} r={5} fill="#ffb703" />
        </svg>
        <div style={{ position: "absolute", left: 0, right: 0, bottom: 8, textAlign: "center" }}>
          <Space direction="vertical" size={2}>
            <Title level={2} style={{ margin: 0, color: "#ffb703" }}>{percent}%</Title>
            <Text type="secondary">{subtitle}</Text>
          </Space>
        </div>
      </div>
      <Space size={24} style={{ marginTop: 8 }}>
        <Space direction="vertical" size={2}>
          <Text type="secondary">План</Text>
          <Title level={5} style={{ margin: 0 }}>{new Intl.NumberFormat("ru-RU").format(plan)} ₸</Title>
        </Space>
        <Space direction="vertical" size={2}>
          <Text type="secondary">Факт</Text>
          <Title level={5} style={{ margin: 0 }}>{new Intl.NumberFormat("ru-RU").format(fact)} ₸</Title>
        </Space>
      </Space>
    </Card>
  );
}


